import getFolderDisplayName from './getFolderDisplayName';
import { compare } from 'owa-datetime';
import { TodoFolder } from 'owa-todo-types';

export default function sortFoldersForDisplay(folders: TodoFolder[]): TodoFolder[] {
    // Add My Day view is tracked by VSO: 30588
    const nonSpecialFolders: TodoFolder[] = [];
    let defaultFolder: TodoFolder | null = null;
    let commitmentsFolder: TodoFolder | null = null;
    let flaggedEmailsFolder: TodoFolder | null = null;

    folders.forEach(folder => {
        if (folder.IsDefaultFolder) {
            defaultFolder = { ...folder };
            defaultFolder.Name = getFolderDisplayName(folder);
        } else if (folder.FolderType === 'Commitments') {
            commitmentsFolder = { ...folder };
            commitmentsFolder.Name = getFolderDisplayName(folder);
        } else if (folder.FolderType === 'FlaggedEmails') {
            flaggedEmailsFolder = { ...folder };
            flaggedEmailsFolder.Name = getFolderDisplayName(folder);
        } else {
            nonSpecialFolders.push(folder);
        }
    });

    // First sort the regular folders in descending order of OrderDateTime
    const sortedFolders = nonSpecialFolders.sort((lhs: TodoFolder, rhs: TodoFolder) => {
        if (lhs.OrderDateTime && rhs.OrderDateTime) {
            return compare(rhs.OrderDateTime, lhs.OrderDateTime);
        }

        if (lhs.OrderDateTime) {
            return -1;
        }

        if (rhs.OrderDateTime) {
            return 1;
        }

        // both folders don't have OrderDateTime
        return 0;
    });

    // Now add our special folders.
    if (commitmentsFolder) {
        sortedFolders.splice(0, 0, ...[commitmentsFolder]);
    }

    if (flaggedEmailsFolder) {
        sortedFolders.splice(0, 0, ...[flaggedEmailsFolder]);
    }

    if (defaultFolder) {
        sortedFolders.splice(0, 0, ...[defaultFolder]);
    }

    return sortedFolders;
}
